export const PAYMENTS_LIST_MOCK = [
  {
    date: '2024-01-31',
    amount: 1000,
    type: 'Acconto',
    period: 'dal 01/12/2023 al 31/12/2023',
  },
  {
    date: '2024-01-31',
    amount: 1200,
    type: 'Saldo',
    period: 'dal 01/01/2023 al 31/01/2023',
  },
  {
    date: '2023-12-31',
    amount: 1800,
    type: 'Acconto',
    period: 'dal 01/11/2023 al 31/11/2023',
  },
  {
    date: '2023-12-31',
    amount: 1900,
    type: 'Saldo',
    period: 'dal 01/12/2022 al 31/12/2022',
  },
  {
    date: '2023-11-30',
    amount: 1000,
    type: 'Acconto',
    period: 'dal 01/10/2023 al 31/10/2023',
  },
  {
    date: '2023-11-30',
    amount: 970.68,
    type: 'Saldo',
    period: 'dal 01/11/2022 al 30/11/2022',
  },
  {
    date: '2023-10-31',
    amount: 1600,
    type: 'Acconto',
    period: 'dal 01/09/2023 al 31/10/2023',
  },
  {
    date: '2023-10-31',
    amount: 1120,
    type: 'Saldo',
    period: 'dal 01/10/2022 al 31/10/2022',
  },
  {
    date: '2023-09-30',
    amount: 1600,
    type: 'Acconto',
    period: 'dal 01/08/2023 al 31/08/2023',
  },
  {
    date: '2023-09-30',
    amount: 1300,
    type: 'Saldo',
    period: 'dal 01/09/2022 al 30/09/2022',
  },
  {
    date: '2023-08-31',
    amount: 936.32,
    type: 'Acconto',
    period: 'dal 01/07/2023 al 31/07/2023',
  },
  {
    date: '2023-08-31',
    amount: 206.0,
    type: 'Saldo',
    period: 'dal 01/08/2022 al 31/08/2022',
  },
];
